export default function createMultiParamFromArray(key, values) {
  return values
    .map(
      (value, i, arr) =>
        `${key}[]=${value.toString().replace(/\+/g, "%2b")}${
          i < arr.length - 1 ? "&" : ""
        }`
    )
    .join("");
}
